<div class="container-claim-list">
  <div class="claims">
    <div class="header">
      <h2 class="title">{{ listTitle }}</h2>
      <app-table-filter-bar
        #tableFilterBar
        [searchByOptions]="categories"
        [sortByOptions]="sorts"
        [filterByOptions]="filterOptions"
        [basicParams]="basicParams"
        [shouldSendCategoriesInSeparateArray]="true"
      ></app-table-filter-bar>
    </div>

    <div class="claim-list">
      <div class="cl-table-wrap">
        <!-- Header -->
        <div
          class="cl-row cl-header"
          [class.cl-row-has-action]="showPayClaimAction"
          [class.cl-row-has-follow-up]="isPublicClaimsNoContractTab"
        >
          <div class="cl-cell cl-cell-status">Status</div>
          <div class="cl-cell">Claim Number</div>
          <div class="cl-cell">Contract #</div>
          <div class="cl-cell">Claim Adjuster</div>
          <div class="cl-cell">Customer</div>
          <div class="cl-cell">Product</div>
          <div class="cl-cell">Repair Facility</div>
          <div class="cl-cell">Type</div>
          <div class="cl-cell">GAP / Total Loss</div>
          <div class="cl-cell cl-cell-amount">Paid Amount</div>
          <div class="cl-cell cl-cell-amount">Authorized Amount</div>
          <div class="cl-cell" *ngIf="isPublicClaimsNoContractTab">Follow-up Emails</div>
          <div class="cl-cell">Created</div>
          <div class="cl-cell">Creation Source</div>
          <div class="cl-cell cl-cell-center cl-cell-action" *ngIf="showPayClaimAction">Action</div>
          <div class="cl-cell"></div>
        </div>

        <!-- Data rows -->
        <ng-container *ngIf="!isLoading && repeatClaimRow.length > 0 && !serverErrorFetch">
          <a
            class="cl-row cl-data-row"
            [class.cl-row-has-action]="showPayClaimAction"
            [class.cl-row-has-follow-up]="isPublicClaimsNoContractTab"
            *ngFor="let product of repeatClaimRow"
            [routerLink]="(viewClaimLink || '/dashboard/claims/claim-details/') + product.id"
            [ngClass]="{
              'row-older-30': product.isOlderThan30Days && product.status?.name != 'Rejected' && product.status?.name != 'Expired' && product.status?.name != 'Paid',
              'row-older-60': product.isOlderThan60Days && product.status?.name != 'Rejected' && product.status?.name != 'Expired' && product.status?.name != 'Paid',
              'cl-data-row--legal': isLegalClaim(product),
              'cl-data-row--exception': isExceptionClaim(product)
            }"
          >
            <div class="cl-cell cl-cell-status">
              <span
                class="cl-status-badge"
                [attr.title]="product?.status?.name"
                [ngStyle]="{ 'background-color': product?.status?.color, 'color': product?.status?.text_color }"
              >
                {{ product?.status?.name }}
              </span>
            </div>
            <div class="cl-cell cl-claim-number">
              <span class="cl-claim-num-text">{{ product?.code }}</span>
              <svg
                (click)="copyClaimNumber(product?.code, $event, copyMsg)"
                class="cl-copy-icon"
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#c2c8d2"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <rect x="9" y="9" width="11" height="11" rx="2"></rect>
                <path d="M5 15V5a2 2 0 012-2h10"></path>
              </svg>
              <span #copyMsg class="cl-copy-check">✓</span>
              <span *ngIf="isLegalClaim(product)" class="cl-legal-tag">Legal</span>
              <span *ngIf="isExceptionClaim(product)" class="cl-exception-tag">Exception</span>
            </div>
            <div class="cl-cell cl-secondary">{{ product?.contract?.contract_number }}</div>
            <div class="cl-cell cl-secondary-light cl-ellipsis">
              {{ product?.adjustor?.first_name | allLettersCapital : true }}
              {{ product?.adjustor?.last_name | allLettersCapital : true }}
            </div>
            <div class="cl-cell cl-primary">{{ product?.customer?.customer_name | allLettersCapital : true }}</div>
            <div class="cl-cell cl-secondary-light">
              {{ (product?.products && product?.products.length > 0 ? product?.products[0]?.label : '') | allLettersCapital : true }}
            </div>
            <div class="cl-cell cl-secondary-light cl-ellipsis">{{ product?.repair_facility?.name | allLettersCapital : true }}</div>
            <div class="cl-cell">
              <span class="cl-type-badge" *ngIf="product?.products?.[0]?.type?.name">
                {{ product?.products[0]?.type?.name | allLettersCapital : true }}
              </span>
            </div>
            <div class="cl-cell"><span class="cl-type-badge">{{ product?.is_gap ? 'Yes' : 'No' }}</span></div>
            <div class="cl-cell cl-secondary cl-cell-amount">{{ product?.amount | formattedCurrency }}</div>
            <div class="cl-cell cl-secondary cl-cell-amount">{{ product?.authorized_amount | formattedCurrency }}</div>
            <div
              class="cl-cell cl-secondary-light"
              *ngIf="isPublicClaimsNoContractTab"
              [title]="product?.follow_up_emails?.join('\n') || ''"
            >
              {{ product?.follow_up_emails?.length ? product.follow_up_emails.length + ' email(s)' : '—' }}
            </div>
            <div class="cl-cell cl-created">
              <div class="cl-created-date">{{ product?.created_at | formattedDate }}</div>
              <div class="cl-created-time">{{ product?.created_at | date:'hh:mm a' }}</div>
            </div>
            <div class="cl-cell cl-creation-source" [title]="product?.creation_source ?? 'N/A'">
              {{ product?.creation_source ?? 'N/A' }}
            </div>
            <div class="cl-cell cl-cell-center cl-cell-action" *ngIf="showPayClaimAction">
              <button
                type="button"
                class="cl-pay-claim-btn allow-tall-button"
                (click)="$event.preventDefault(); $event.stopPropagation(); payClaim.emit(product)"
                aria-label="Pay claim"
                title="Pay Claim"
              >
                <app-icon name="credit-card" [size]="15" [strokeWidth]="1.8"></app-icon>
              </button>
            </div>
            <div class="cl-cell cl-cell-end">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#c2c8d2" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"></path></svg>
            </div>
          </a>
        </ng-container>

        <!-- Loading rows -->
        <ng-container *ngIf="isLoading">
          <div
            class="cl-row cl-data-row"
            [class.cl-row-has-action]="showPayClaimAction"
            [class.cl-row-has-follow-up]="isPublicClaimsNoContractTab"
            *ngFor="let l of repeatVehicleRow"
          >
            <div class="cl-cell"><ngx-skeleton-loader appearance="line" [theme]="{ width: '60px', height: '22px', 'border-radius': '999px' }"></ngx-skeleton-loader></div>
            <div class="cl-cell"><ngx-skeleton-loader appearance="line" [theme]="{ width: '140px' }"></ngx-skeleton-loader></div>
            <div class="cl-cell"><ngx-skeleton-loader appearance="line" [theme]="{ width: '100px' }"></ngx-skeleton-loader></div>
            <div class="cl-cell"><ngx-skeleton-loader appearance="line" [theme]="{ width: '100px' }"></ngx-skeleton-loader></div>
            <div class="cl-cell"><ngx-skeleton-loader appearance="line" [theme]="{ width: '110px' }"></ngx-skeleton-loader></div>
            <div class="cl-cell"><ngx-skeleton-loader appearance="line" [theme]="{ width: '120px' }"></ngx-skeleton-loader></div>
            <div class="cl-cell"><ngx-skeleton-loader appearance="line" [theme]="{ width: '100px' }"></ngx-skeleton-loader></div>
            <div class="cl-cell"><ngx-skeleton-loader appearance="line" [theme]="{ width: '60px' }"></ngx-skeleton-loader></div>
            <div class="cl-cell"><ngx-skeleton-loader appearance="line" [theme]="{ width: '55px' }"></ngx-skeleton-loader></div>
            <div class="cl-cell"><ngx-skeleton-loader appearance="line" [theme]="{ width: '55px' }"></ngx-skeleton-loader></div>
            <div class="cl-cell"><ngx-skeleton-loader appearance="line" [theme]="{ width: '80px' }"></ngx-skeleton-loader></div>
            <div class="cl-cell"><ngx-skeleton-loader appearance="line" [theme]="{ width: '80px' }"></ngx-skeleton-loader></div>
            <div class="cl-cell" *ngIf="isPublicClaimsNoContractTab"><ngx-skeleton-loader appearance="line" [theme]="{ width: '80px' }"></ngx-skeleton-loader></div>
            <div class="cl-cell"><ngx-skeleton-loader appearance="line" [theme]="{ width: '90px' }"></ngx-skeleton-loader></div>
            <div class="cl-cell"><ngx-skeleton-loader appearance="line" [theme]="{ width: '100px' }"></ngx-skeleton-loader></div>
            <div class="cl-cell cl-cell-center cl-cell-action" *ngIf="showPayClaimAction"><ngx-skeleton-loader appearance="circle" [theme]="{ width: '31px', height: '31px' }"></ngx-skeleton-loader></div>
            <div class="cl-cell"></div>
          </div>
        </ng-container>

        <!-- No data -->
        <div *ngIf="!isLoading && repeatClaimRow.length === 0 && !serverErrorFetch" class="cl-no-data">
          There are no claims at the moment.
        </div>
      </div>

      <!-- Server error -->
      <div *ngIf="serverErrorFetch" class="internal-server-error">
        {{ serverErrorFetch }}
      </div>

      <!-- Footer -->
      <div class="cl-footer" *ngIf="totalItems">
        <div class="cl-footer-text">Showing {{ repeatClaimRow.length }} of {{ totalItems }} claims</div>
        <app-paginator
          [total]="totalItems"
          [rowsPerPage]="rowsPerPage"
        ></app-paginator>
      </div>
    </div>
  </div>
</div>
